var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactiveQuery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H10M4 6H7M0.5 7.00623C0.5 8.07362 1.24894 9.0027 2.30497 9.15797C3.05731 9.26859 3.81816 9.35303 4.58657 9.41034C4.82003 9.42775 5.03345 9.55017 5.16331 9.74496L7 12.5L8.83667 9.745C8.96653 9.55021 9.17995 9.42778 9.41342 9.41038C10.1818 9.35309 10.9427 9.26866 11.695 9.15805C12.751 9.00279 13.5 8.0737 13.5 7.0063V2.9937C13.5 1.92631 12.751 0.997218 11.695 0.841957C10.1627 0.616676 8.59507 0.5 7.00019 0.5C5.40517 0.5 3.83741 0.616696 2.30498 0.842017C1.24894 0.99729 0.5 1.92637 0.5 2.99376V7.00623Z",
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactiveQuery);
export default __webpack_public_path__ + "static/media/deactive-query.ee8ecb55c03fe496b89c97f05acc2a02.svg";
export { ForwardRef as ReactComponent };